export default __webpack_public_path__ + "static/media/d_technology.a3fb2b6f.png";